import { render, staticRenderFns } from "./usuarioNuevo.vue?vue&type=template&id=336b3acb&scoped=true"
import script from "./usuarioNuevo.vue?vue&type=script&lang=js"
export * from "./usuarioNuevo.vue?vue&type=script&lang=js"
import style0 from "./usuarioNuevo.vue?vue&type=style&index=0&id=336b3acb&prod&scoped=true&lang=css"
import style1 from "./usuarioNuevo.vue?vue&type=style&index=1&id=336b3acb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b3acb",
  null
  
)

export default component.exports